import LeftmenuConst from '../constants/leftmenu.constants';


const LeftMenus = ['rbr', 'board', 'mywork', 'team', 'goal', 'meeting', 'hr'];

const LeftmenuReducers = (state = {}, action) => {
  const initialState = state;
  switch (action.type) {
    case LeftmenuConst.UPDATE_KEEP_OPEN:
      for (const m of initialState.topmenus) {
        if (typeof initialState[m] !== 'undefined' && initialState[m]) {
          initialState[m].keep_open = action.keep_open;
        }
      }
      state = { ...state, ...initialState };
      break;
    case LeftmenuConst.LOAD_MENU_DATA:
      initialState.refresh_page = false;
      initialState[action.menuId] = action.data;
      if (action.activeMenuId) {
        initialState.activeMenuId = action.activeMenuId;
      }
      state = { ...state, ...initialState };
      break;
    case LeftmenuConst.SORTING_MENU_ITEM:
      initialState[action.menuId] = action.data;
      state = { ...state, ...initialState };
      break;
    case LeftmenuConst.UPDATE_COLLAPSE_MENU:
      if (typeof initialState[action.menuId] !== 'undefined' && initialState[action.menuId]) {
        // console.log('UPDATE_KEEP_OPEN');
        initialState[action.menuId].collapse_all = action.collapse_all;
        initialState[action.menuId].menus = initialState[action.menuId].menus.map((m) => {
          m.expand = action.collapse_all == '1';
          return m;
        });
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.UPDATE_COLLAPSE_SINGLE_MENU:
      if (typeof initialState[action.menuId] !== 'undefined' && initialState[action.menuId]) {
        initialState[action.menuId].menus = initialState[action.menuId].menus.map((m) => {
          if (m.id == action.id) {
            m.expand = action.collapse;
          }
          return m;
        });
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.ACTIVE_LEFTMENU:
      initialState.activeMenuId = action.menuId;
      if (typeof initialState[action.menuId] !== 'undefined') {
        if (typeof action.highLightObjectId !== 'undefined' && action.highLightObjectId) {
          initialState[action.menuId].highLightObjectId = action.highLightObjectId;
        }
        if (typeof action.highLightObjectType !== 'undefined' && action.highLightObjectType) {
          initialState[action.menuId].highLightObjectType = action.highLightObjectType;
        } else if (action.menuId == 'goal') {
          initialState[action.menuId].highLightObjectType = '';
        }
      }
      state = { ...state, ...initialState };
      break;
    case LeftmenuConst.HIGHLIGHT_LEFTMENU_OBJECTID:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId]) {
        initialState[action.pageId].highLightObjectId = action.objectId;
        if (typeof action.objectType !== 'undefined' && action.objectType) {
          initialState[action.pageId].highLightObjectType = action.objectType;
        }
        if (typeof action.additionalParams !== 'undefined') {
          initialState[action.pageId].additionalParams = action.additionalParams;
        }
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.LEFTMENU_SORTING:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId]) {
        initialState[action.pageId].sorting[action.menuId] = action.ids;
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.UPDATE_LEFTMENU_DATA:
      if (typeof initialState[action.pageId]?.menus !== 'undefined') {
        if (action.objectId) {
          initialState[action.pageId].menus = initialState[action.pageId].menus.map((m) => {
            if (Array.isArray(m.menus) && m.menus.length) {
              m.menus = m.menus.map((m1) => {
                if (new String(m.id).indexOf('favorites') !== -1) {
                  if (m1.obj_id == action.objectId && m1.obj_type == action.objectType) {
                    m1 = Object.assign({}, m1, action.data);
                  }
                } else if (m1.id == action.objectId) {
                  m1 = Object.assign({}, m1, action.data);
                }
                return m1;
              });
            }
            return m;
          });
        }
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.DELETE_LEFTMENU_DATA:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId]) {
        if (action.objectId && typeof initialState[action.pageId].menus !== 'undefined') {
          initialState[action.pageId].menus = initialState[action.pageId].menus.map((m) => {
            if (Array.isArray(m.menus) && m.menus.length) {
              if (new String(m.id).indexOf('favorites') !== -1) {
                m.menus = m.menus.filter(m1 => !(m1.obj_id == action.objectId && m1.obj_type == action.objectType));
              } else {
                m.menus = m.menus.filter(m1 => m1.id != action.objectId);
              }
            }
            return m;
          });
        }
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.PIN_LEFTMENU_DATA:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId]) {
        if (action.objectId && typeof initialState[action.pageId].menus !== 'undefined' 
          && Array.isArray(initialState[action.pageId].menus)) {
          initialState[action.pageId].menus = initialState[action.pageId].menus.map((m) => {
            if (new String(m.id).indexOf('favorites') !== -1) {
              if (Array.isArray(m.menus) && m.menus.length) {
                if (action.pinStatus == '1') {
                  if (Object.keys(action.data).length) {
                    const keyExists = m.menus.some((ele) => ele?.obj_id === action.data?.obj_id);
                    if (!keyExists) {
                      m.menus.unshift(action.data);
                    }
                    // const sortingI = (action.pageId == 'board') ? `${action.objectType}_${action.data.obj_id}` : action.data.obj_id;
                    // if (typeof initialState[action.pageId].sorting[`${action.pageId}_favorites`] === 'undefined') {
                    //   initialState[action.pageId].sorting[`${action.pageId}_favorites`] = [];
                    // }
                    // initialState[action.pageId].sorting[m.id] = initialState[action.pageId].sorting[`${action.pageId}_favorites`].filter(s => s != sortingI);
                    // initialState[action.pageId].sorting[m.id].unshift(sortingI);
                  }
                } else {
                  if (action.pageId == 'board') {
                    m.menus = m.menus.filter(m1 => !(m1.obj_id == action.objectId && m1.obj_type == action.objectType));
                  } else {
                    m.menus = m.menus.filter(m1 => m1.obj_id != action.objectId);
                  }
                  // if(typeof initialState[action.pageId]['sorting'][action.pageId+'_favorites'] !== 'undefined'){
                  //     let sortingD = (action.pageId == 'board') ? action.data.obj_type + "_" + action.data.obj_id : action.data.obj_id;
                  //     initialState[action.pageId]['sorting'][action.pageId+'_favorites'] = initialState[action.pageId]['sorting'][action.pageId+'_favorites'].filter(del =>
                  //         (action.pageId == 'board') ? action.pageId + "_" + action.objectId != del.obj_type+'_'+del.obj_id : del.obj_id != action.objectId)
                  // }
                }
              } else {
                if (!Array.isArray(m.menus)) {
                  m.menus = [];
                }
                if (Object.keys(action.data).length) {
                  m.menus = m.menus.concat(action.data);
                }
              }
            }
            return m;
          });
        }
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.UPDATE_MYWORK_COUNT:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId] && typeof initialState[action.pageId].links !== 'undefined' && initialState[action.pageId].links) {
        initialState[action.pageId].links = initialState[action.pageId].links.map((l) => {
          if (typeof action.countData[l.id] !== 'undefined' && action.countData[l.id] >= 0) {
            l.count = action.countData[l.id];
          }
          return l;
        });
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.UPDATE_KRS_COUNT:
      if (typeof initialState[action.pageId] !== 'undefined' && initialState[action.pageId]
      && typeof initialState[action.pageId].links !== 'undefined' 
      && Array.isArray(initialState[action.pageId].links)
      ) {
        initialState[action.pageId].links = initialState[action.pageId].links.map((l) => {
          if (typeof action.countData[l.id] !== 'undefined' && (action.countData[l.id] || action.countData[l.id] == 0)) {
            l.count = action.countData[l.id];
          }
          return l;
        });
        state = { ...state, ...initialState };
      }
      break;
    case LeftmenuConst.UPDATE_WS_LEFT_MENU:
      if(action.menuId == 'board'){
        const resultData = [...initialState[action.menuId].menus,...action.data.data].reduce((res, data) => {
          if (res.findIndex(menu => menu.id === data.id ) < 0) { 
              res.push(data);
          }  
          return res;
        }, []);
        const lastIndexed = resultData.filter(res => (res.id == -1 || res.id == -2 || res.id == -3));
        const filteredResult = resultData.filter(res => (res.id != -1 && res.id != -2 && res.id != -3));
        const finalResult = filteredResult.concat(lastIndexed);
        initialState[action.menuId].menus = finalResult;
        state = { ...state, ...initialState };
      }
      //return state;
      break;
    default:
      break;
  }
  return state;
};

export default LeftmenuReducers;
